export default "__VITE_ASSET__DgR1iePp__ 402w";